// (c) chaehongee. Confidential and proprietary.

import type { AppDispatch } from '../../../store/store'
import { setContextUsage, setMessages } from '../../../store/slices/chatSlice'
import { parseSessionMessages } from '../utils/chatParsers'
import type { SessionInfoResponse } from 'models-ts/session'

export class ChatService {
    static syncMessages(
        dispatch: AppDispatch,
        sessionId: string,
        session: SessionInfoResponse | null
    ) {
        if (!session) {
            dispatch(setMessages({ sessionId, messages: [] }))
            dispatch(setContextUsage({ sessionId, contextUsage: null }))
            return
        }

        const usage = session.last_context_usage
        if (usage) {
            dispatch(
                setContextUsage({
                    sessionId,
                    contextUsage: {
                        model: usage.model,
                        inputTokens: usage.input_tokens,
                        outputTokens: usage.output_tokens,
                        outputTokenLimit: usage.output_token_limit,
                        contextWindowLimit: usage.context_window_limit,
                    },
                })
            )
        }

        const messages = parseSessionMessages(session.messages)
        // Only update if we have messages to show, to avoid wiping out optimistic updates
        // when the backend hasn't caught up yet
        if (messages.length > 0) {
            dispatch(setMessages({ sessionId, messages }))
        }
    }
}
